import '../../css/Login.css';
import { InputAdornment, IconButton, TextField, Select, SelectChangeEvent, MenuItem } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import React, { useContext, useState, useEffect } from 'react';
import CardAtom from '../../atoms/Card/Card';
import AuthContext from '../../store/auth-context';
import ButtonGST from "../../atoms/Controls/ButtonGTS";
import Form from 'react-bootstrap/Form';
import { IGlobalPoprop } from "../../interfaces/global-interface";
import { getServiceData } from "../../store/global-services";
import { useNavigate  } from 'react-router-dom';
import { UrlSiteBase } from '../../Global';

function Login(globalProp?: IGlobalPoprop) {
  const [enteredEmail, setEnteredEmail] = useState('');
  const [enteredPassword, setEnteredPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [distribuidoras, setDistribuidoras] = useState<any>([]);
  const [distribuidora, setDistribuidora] = useState('-1');
  const navigate = useNavigate();

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  let { UrlBase } = UrlSiteBase();
  const authContext = useContext(AuthContext);
  const onLogin = (data: any) => {
    if (!data.success && globalProp && globalProp.snackHandleOpen)
      globalProp.snackHandleOpen({open: true, message: data.message, color: "red"});
    if (globalProp && globalProp.loginHandler)
      globalProp.loginHandler(data);
    if (data.success)
      navigate(UrlBase + 'homepage');
    
  }
  const submitHandler = (e:any) => {
    authContext.onLogin(enteredEmail, enteredPassword, distribuidora, onLogin);
  }
  const emailChangeHandler = (event: any) => {
    setEnteredEmail(event.target.value)
  }
  const passwordChangeHandler = (event: any) => {
    setEnteredPassword(event.target.value)
  }
  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;
    setDistribuidora(value);
  }
  useEffect(() => {
    getServiceData({ nombre: 'distribuidoras', parametros: {estatus: 1}}).then(data => {
      if (data.success && data.distribuidoras)
        setDistribuidoras([...data.distribuidoras]);
    });
  }, []);
  return (
    <>
    <CardAtom>
      <Form className='form-gts login'>
        <Form.Group className='mb-3' controlId='usuario'>
          <TextField id="usuario" onChange={emailChangeHandler} value={enteredEmail} label="Usuario" color="secondary" />
        </Form.Group>
        <Form.Group className='mb-3' controlId='email'>
          <TextField id="password" onChange={passwordChangeHandler} type={showPassword ? "text" : "password"} value={enteredPassword} label="Contraseña" color="secondary"
            InputProps={{ endAdornment: 
              <InputAdornment position="end">
                <IconButton onClick={handleClickShowPassword} edge="end" onMouseDown={handleMouseDownPassword}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment> }} 
          />
        </Form.Group>
        <Form.Group className='mb-3' controlId='distribuidora'>
          <Select className='distribuidora' labelId="Distribuidora" id="distribuidora" name="idDistribuidora" value={distribuidora} label="Distribuidora" onChange={handleSelectChange}>
                <MenuItem value={'-1'}>Sin distribuidora</MenuItem>
                {distribuidoras?.map((distribuidora: any) => (
                  <MenuItem key={"item-" + distribuidora?.id} value={distribuidora?.id}>{distribuidora?.nombre}</MenuItem>
                ))}
          </Select>
        </Form.Group>
        <div className="panel-actions">
          <ButtonGST onClick={submitHandler}>Ingresar</ButtonGST>
        </div>
      </Form>
    </CardAtom>
    </>
  )
}

export default Login;